/* eslint-disable no-console */

/**
 * Método DispositivoSoportaNFC
 * @returns retorna una operación asíncrona que retorna true si el dispositivo dispone de técnologia NFC
 * o el fracaso si el dispositivo no soporta NFC.
 */
export function DispositivoSoportaNFC() {
  console.log('soporteNFC->DispositivoSoportaNFC');
  return new Promise((resolve) => {
    const onSuccess = () => {
      console.log('Dispositivo soporta NFC');
      resolve(true);
    };
    const onFailure = (error) => {
      if (error === 'NFC_DISABLED') {
        resolve(true);
      } else if (error === 'NO_NFC') {
        console.log(`Dispositivo NO soporta NFC: ${error}`);
        resolve(false);
      }
      resolve(false);
    };

    if (!window.nfc) {
      onFailure('NO_NFC');
    } else {
      window.nfc.enabled(onSuccess, onFailure);
    }
  });
}

/**
 * Método DispositivoConNFCHabilitado
 * @returns retorna una operación asíncrona que retorna true si el dispositivo tiene NFC habilitado
 * o false si el dispositivo no dispone de NFC o este no esta habilitado.
 */
export function DispositivoConNFCHabilitado() {
  console.log('soporteNFC->DispositivoConNFCHabilitado');
  return new Promise((resolve) => {
    const onSuccess = () => {
      console.log('Dispositivo soporta NFC');
      resolve(true);
    };
    const onFailure = (error) => {
      if (error === 'NFC_DISABLED') {
        console.log(`Dispositivo con NFC Deshabilitado: ${error}`);
      } else if (error === 'NO_NFC') {
        console.log(`Dispositivo NO soporta NFC: ${error}`);
      }
      resolve(false);
    };

    if (!window.nfc) {
      onFailure('NO_NFC');
    } else {
      window.nfc.enabled(onSuccess, onFailure);
    }
  });
}
